import {
  ADD_UPDATE_HPE_CUSTOMER_FAILURE,
  ADD_UPDATE_HPE_CUSTOMER_REQUEST,
  ADD_UPDATE_HPE_CUSTOMER_SUCCESS,
  FETCH_HPE_CUSTOMER_LIST_FAILURE,
  FETCH_HPE_CUSTOMER_LIST_REQUEST,
  FETCH_HPE_CUSTOMER_LIST_SUCCESS,
} from "./actionTypes";
import { HPECustomerState } from "./types";

// Initial state for customer reducer
const initialCustomerState: HPECustomerState = {
  hpeCustomersList: [],
  loading: false,
  error: null,
  totalCount: 0,
  successMessage: null,
};

// Customer reducer
const HPECustomerReducer = (
  state = initialCustomerState,
  action: any,
): HPECustomerState => {
  switch (action.type) {
    case FETCH_HPE_CUSTOMER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_HPE_CUSTOMER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        hpeCustomersList:
          action.payload.HPECustomerList || action.payload,
        totalCount: action.payload.totalCount || 0,
      };

    case FETCH_HPE_CUSTOMER_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ADD_UPDATE_HPE_CUSTOMER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ADD_UPDATE_HPE_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: action.payload,
      };

    case ADD_UPDATE_HPE_CUSTOMER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default HPECustomerReducer;
